<template>
  <div>
    <b-tabs
      pills
      fill
    >
      <b-tab>
        <template #title>
          <feather-icon icon="InfoIcon" />
          Genel Bilgiler
        </template>
        <product-form-card />
      </b-tab>
      <b-tab
        :disabled="!itemData.id"
        lazy
      >
        <template #title>
          <feather-icon icon="InfoIcon" />
          Ayrıntılar
        </template>
        <product-items-form />
      </b-tab>
      <b-tab
        :disabled="!itemData.id"
        lazy
      >
        <template #title>
          <feather-icon icon="InfoIcon" />
          Galeri
        </template>
        <products-photo-gallery />
      </b-tab>
      <b-tab
        :disabled="!itemData.id"
        lazy
      >
        <template #title>
          <feather-icon icon="InfoIcon" />
          Seo Bilgileri
        </template>
        <seo-component data-store="products/dataItem" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BTab, BTabs,
} from 'bootstrap-vue'
import ProductFormCard from '@/views/Admin/Products/Components/ProductForm.vue'
import SeoComponent from '@/layouts/components/common/SeoComponent.vue'
import ProductsPhotoGallery from '@/views/Admin/Products/Components/ProductGallery.vue'
import ProductItemsForm from '@/views/Admin/Products/Components/ItemsForm.vue'

export default {
  name: 'ProductsItemForm',
  components: {
    ProductItemsForm,
    ProductsPhotoGallery,
    SeoComponent,
    ProductFormCard,
    BTabs,
    BTab,
  },
  computed: {
    itemData() {
      return this.$store.getters['products/dataItem']
    },
  },
}
</script>
